import AudienceNameCellRenderer from './AudienceNameCellRenderer';

export const SegmentNameCellRenderer = props => AudienceNameCellRenderer({ ...props, fieldName: 'segment' });
